import { MaskLine, Reveal } from "./Reveal";

export const SectionHead = ({ eyebrow, lines, intro, dark = false, testid }) => (
  <div data-testid={testid}>
    <Reveal>
      <p className={`eyebrow flex items-center gap-3 ${dark ? "text-[#86C89B]" : "text-[#3E6B48]"}`}>
        <span className={`w-10 h-px ${dark ? "bg-[#86C89B]" : "bg-[#3E6B48]"}`} /> {eyebrow}
      </p>
    </Reveal>
    <h2 className={`f-serif mt-6 text-4xl sm:text-5xl lg:text-6xl leading-[0.98] tracking-[-0.02em] ${dark ? "text-[#FCFBF7]" : "text-[#1B3B28]"}`}>
      {lines.map((l, i) => (
        <MaskLine key={i} inView delay={i * 0.1} className={i === lines.length - 1 ? `italic ${dark ? "text-[#86C89B]" : "text-[#3E6B48]"}` : ""}>
          {l}
        </MaskLine>
      ))}
    </h2>
    {intro && (
      <Reveal delay={0.2}>
        <p className={`mt-8 max-w-xl text-base sm:text-lg leading-relaxed ${dark ? "text-[#FCFBF7]/70" : "text-[#526356]"}`}>{intro}</p>
      </Reveal>
    )}
  </div>
);
